import { Box, Button, Grid, Tab, Tabs, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import { courseOptions, intakeOptions, courses } from './data/data';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Batch from './Batch';
import Program from './Program';
import Specialization from './Specialization';

const defaultValues = {
  program: '',
  intake: '',
  course: '',
  startDate: '',
  endDate: '',
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    margin: '1rem 0',
    padding: theme.spacing(2),
    minHeight: '80vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.KenColors.kenWhite,

    '& .MuiTextField-root': {
      margin: '0px',
      width: '100%',
    },

    '& .Mui-selected': {
      fontSize: '10px',
      background: '#03248F',
      borderRadius: '50px',
      padding: '0',
      color: '#fff',
      minWidth: '100px',
      margin: '0 10px 0 0 !important',
      minHeight: '35px',
      height: '35px',
    },
  },
  heading: {
    fontSize: 18,
    fontWeight: 700,
    color: '#061938',
    margin: 5,
  },
  tabBtn: {
    fontSize: '10px',
    background: '#03248F',
    borderRadius: '50px',
    padding: '0',
    color: '#fff',
    minWidth: '100px',
    margin: '0 10px 0 0 !important',
    minHeight: '35px',
    height: '35px',
  },
  tabBtnBlur: {
    fontSize: '10px',
    background: '#CCD1D8',
    borderRadius: '50px',
    padding: '0',
    color: '#000',
    minWidth: '100px',
    margin: '0 10px 0 0 !important',
    minHeight: '35px',
    height: '35px',
  },
}));

const ProgramFilter = (props) => {
  const classes = useStyles();
  const [formValues, setFormValues] = useState(defaultValues);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    // setBreadValue(breadCrumbsMenu[newValue])
    setValue(newValue);
  };

  function a11yProps(index) {
    console.log('index', index);
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const handleFilters = () => {
    props.setFilters(formValues);
    props.setIsFiltered(true);
  };
  function TabPanels(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: '10px' }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  console.log('{...a11yProps(0)} ', { ...a11yProps(0) }, value);
  return (
    <Box className={classes.root}>
      <Tabs
        style={{
          padding: '0 14px',
        }}
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        <Tab
          className={value == 0 ? classes.tabBtn : classes.tabBtnBlur}
          label="Program"
          {...a11yProps(0)}
          style={{ fontSize: '10px' }}
        />
        <Tab
          className={value == 1 ? classes.tabBtn : classes.tabBtnBlur}
          label="Intake"
          {...a11yProps(1)}
          style={{ fontSize: '10px' }}
        />
        <Tab
          className={value == 2 ? classes.tabBtn : classes.tabBtnBlur}
          label="Specialization"
          {...a11yProps(2)}
          style={{ fontSize: '10px' }}
        />
      </Tabs>
      <TabPanels value={value} index={0}>
        <Program props={props} />
      </TabPanels>
      <TabPanels value={value} index={1}>
        <Batch props={props} />
      </TabPanels>
      <TabPanels value={value} index={2}>
        {/* <ExamFees /> */}
        <Specialization props={props} />
      </TabPanels>
    </Box>
  );
};

export default ProgramFilter;